import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { searchClients } from "../http";
import styles from "./ClientSearchSelect.module.scss"; 

const ClientSearchSelect = ({
  onClientSelect,
  placeholder = "Search clients...",
  currentClient,
  carId
}) => {

  console.log(carId)

  const [selectedClient, setSelectedClient] = useState(
    currentClient
      ? {
          value: currentClient.id,
          label: currentClient.fullname,
        }
      : null
  );

  useEffect(() => {
    if (currentClient) {
      setSelectedClient({
        value: currentClient.id,
        label: currentClient.fullname,
      });
    } else {
      setSelectedClient(null);
    }
  }, [currentClient]);

  const loadClients = async (inputValue) => {
    // if (!carId) return [];
    try {
      const fetchedClients = await searchClients(inputValue, carId !== undefined ? carId : null);
      return fetchedClients.map((client) => ({
        value: client.id,
        label: client.fullname,
      }));
    } catch (error) {
      console.error("Error fetching clients:", error);
      alert("Failed to fetch clients. Please try again later.");
      return [];
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedClient(selectedOption);
      onClientSelect(selectedOption.value, selectedOption.label);
    }
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>{placeholder}</label>
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={loadClients}
        onChange={handleChange}
        placeholder={placeholder}
        value={selectedClient}
        aria-label="Client search"
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: "white",
            borderColor: "#ced4da",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#80bdff",
            },
            borderRadius: "var(--input-border-radius)", 
            padding: "0.5rem", 
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: "white",
            zIndex: 5,
          }),
          placeholder: (base) => ({
            ...base,
            color: "#6c757d",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#495057",
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#f1f4f8",
            color: "#495057",
            borderRadius: "var(--input-border-radius)", 
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "#495057",
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: "#d9534f",
            ":hover": {
              backgroundColor: "#f5c6cb",
              color: "#a94442",
            },
          }),
        }}
      />
    </div>
  );
};

export default ClientSearchSelect;
